module.exports = __webpack_public_path__ + "media/images/icons8-map-48-c171f87937c2f0326fa5fc6c72243393.png";